// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2
import { SvgIconProps } from '@mui/material';

import AccessibleSvgIcon from './helpers/AccessibleSvgIcon';
import Sort from './source/sort.svg?react';

const SortIcon = (props: SvgIconProps) => <AccessibleSvgIcon {...props} component={Sort} />;

export default SortIcon;
